import { OnboardingDocumentMessage } from '../../../types/OnboardingDocumentMessage';
import { IconButton } from '../../cdl/IconButton/IconButton';
import { Text } from '../../cdl/Text/Text';
import { formatDateTime } from '../../common/helpers/formatDateTime.helper';
import { translate } from '../../common/helpers/translate.helper';
import { IconTrash } from '../../common/icons/cdl/Trash';
import { Box } from '../../common/ui/Box';

interface DocumentRowProps {
    document: OnboardingDocumentMessage;
    onRemove?: () => void;
    removeDisabled?: boolean;
}

export const DocumentRow = ({ document, onRemove, removeDisabled }: DocumentRowProps) => (
    <Box display="flex" alignItems="center" gap={8}>
        <Box display="grid" padding={4} flex="1 0 0" minWidth={0}>
            <Text size={14} weight="semi" color="accent.foreground">
                {document.name}
            </Text>
            {document.dateUploaded ? (
                <Text size={12} color="foreground.muted">
                    {translate('supplierOnboarding.modal.uploadedAt', {
                        date: formatDateTime({ date: document.dateUploaded }),
                    })}
                </Text>
            ) : null}
        </Box>
        {onRemove ? <IconButton Icon={IconTrash} disabled={removeDisabled} onClick={onRemove} /> : null}
    </Box>
);
